// extracted by mini-css-extract-plugin
export default {"loading_component":"LoadingComponent_loading_component__PtYFJ","loader":"LoadingComponent_loader__OadE5","rotation":"LoadingComponent_rotation__BHeKp"};